import React from "react";
import "./currency.css";

/** UAE Dirham — used across booking UI */
export const CURRENCY_SYMBOL = "AED";
export const CURRENCY_AED_SYMBOL_CLASS = "currency-aed-symbol";

export const shouldUseAedSymbolFont = (symbol) =>
  String(symbol ?? "")
    .trim()
    .toUpperCase() === CURRENCY_SYMBOL;

export const getCurrencySymbolClassName = (symbol = CURRENCY_SYMBOL) =>
  shouldUseAedSymbolFont(symbol) ? CURRENCY_AED_SYMBOL_CLASS : undefined;

export const CurrencySymbol = ({ symbol = CURRENCY_SYMBOL, className }) => {
  const currencySymbolClass = getCurrencySymbolClassName(symbol);
  const classes = [currencySymbolClass, className].filter(Boolean).join(" ") || undefined;
  return <span className={classes}>{symbol}</span>;
};

export const formatCurrency = (amount, symbol = CURRENCY_SYMBOL) => {
  const formatted = new Intl.NumberFormat("en-AE").format(amount || 0);
  return (
    <>
      <CurrencySymbol symbol={symbol} /> {formatted}
    </>
  );
};
